import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { createPinia } from 'pinia'
import { useSystemStore } from '@/stores/system'
import { setupFetchInterceptor } from '@/lib/fetch-interceptor'

// 注册全局 fetch 拦截器
setupFetchInterceptor()

// 添加所有solid和regular图标到库中
library.add(fas, far)

// 创建Vue应用实例
const app = createApp(App)

// 注册FontAwesomeIcon组件
app.component('font-awesome-icon', FontAwesomeIcon)

// 创建并使用Pinia
const pinia = createPinia()
app.use(pinia)

// 使用路由
app.use(router)

// 使用 Ant Design Vue
app.use(Antd)

// 在挂载前请求系统配置和高级接口配置
const initApp = async () => {
  try {
    const systemStore = useSystemStore()
    await Promise.all([
      systemStore.fetchSystemConfig(),
      systemStore.fetchAdvancedApiConfig(),
    ])
    console.log('System config and advanced API config loaded successfully')
  } catch (error) {
    console.error('Failed to load application config:', error)
  }
  
  // 挂载应用
  app.mount('#app')
}

// 初始化应用
initApp()
